"use strict";
exports.__esModule = true;
exports.fail = exports.assert = void 0;
/**
 * Test if the `condition` is truthy. If `condition` is false, it throws
 * an error with an optional message. If the message parameter is missing,
 * it throws an error with a default message.
 */
function assert(condition, msg) {
    if (!condition) {
        fail(msg);
    }
}
exports.assert = assert;
/**
 * Throws an Error with the (optionally) provided error message.
 */
function fail(msg) {
    throw new Error("INTERNAL ASSERTION FAILED: ".concat(msg));
}
exports.fail = fail;
